import script from "./CardPackView.vue?vue&type=script&setup=true&lang=js"
export * from "./CardPackView.vue?vue&type=script&setup=true&lang=js"

import "./CardPackView.vue?vue&type=style&index=0&id=fa45626c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fa45626c"]])

export default __exports__